import { Autocomplete } from "@/components/atoms";
import { AutocompleteOption } from "@/components/atoms/Autocomplete";
import { useCredentials } from "@/hooks";
import { UserCredential } from "@/types/user";
import { Credential } from "@/types/jobPost";
import { useEffect, useRef } from "react";

export interface UserCredentialDropdownProps {
  userCredentials: UserCredential[];
  selectedCredentials: Credential[];
  setSelectedCredentials: (selectedCredentials: Credential[]) => void;
}

export const UserCredentialDropdown = ({
  userCredentials,
  selectedCredentials,
  setSelectedCredentials,
}: UserCredentialDropdownProps) => {
  const { credentials, loading: credentialsLoading } = useCredentials();

  const options =
    credentials?.map(credential => ({
      key: credential.id,
      value: credential.credential_name,
      display: `${credential.credential_name} (${credential.credential_code})`,
    })) || [];

  const hasInitialized = useRef(false);

  useEffect(() => {
    if (
      !hasInitialized.current &&
      !selectedCredentials?.length &&
      userCredentials?.length
    ) {
      const creds = userCredentials.map(uc => uc.credential);
      setSelectedCredentials(creds);
      hasInitialized.current = true;
    }
  }, [userCredentials, selectedCredentials, setSelectedCredentials]);

  const selectedOptions: AutocompleteOption[] =
    selectedCredentials?.map(credential => ({
      key: credential.id,
      value: credential.credential_name,
      display: `${credential.credential_name} (${credential.credential_code})`,
    })) || [];

  return (
    <Autocomplete
      componentName={"credentials"}
      multiple
      inputLabel="Credentials"
      options={options}
      value={selectedOptions}
      onChange={(_, value) => {
        const selectedValues = (value as AutocompleteOption[]).filter(Boolean);

        const selected = credentials?.filter(credential =>
          selectedValues.some(el => el.key === credential.id),
        );

        if (selected) {
          setSelectedCredentials(selected);
        }
      }}
      loading={credentialsLoading}
      renderCheckMarks
      disableClearable
    />
  );
};
